export function BrandMark({ size = 32, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="TrendMing"
      role="img"
    >
      <rect width="1024" height="1024" rx="180" ry="180" fill="#3B6FD4" />
      <rect x="172" y="210" width="680" height="155" rx="12" ry="12" fill="white" />
      <rect x="424" y="330" width="176" height="480" rx="12" ry="12" fill="white" />
      <path d="M 195 695 Q 480 750 790 270" stroke="white" strokeWidth="48" fill="none" strokeLinecap="round" />
      <polygon points="832,228 745,248 790,320" fill="white" />
      <circle cx="850" cy="215" r="48" stroke="white" strokeWidth="36" fill="none" />
    </svg>
  );
}

export default BrandMark;
